export const DATA_TEST_ID_PREFIX = 'accordion-'
